// src/pages/PortPilotLoginPage.jsx
// ����~Z��s��?�T�^S UI �^؇<?�.<�`��??��O�'�?^�-��,?��_��s�^?�SY�T��.��T,�?O�T,�_��.� pp_auth �^� pp_user��O�,�_O��Z�?` /my-containersa?,
// ��_����݄���""�?.�s,�"S�?_�,?�_<�<�-؋�>�,-�-؆�.��o�,��"���a?,

import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { saveAuth, refreshUserProfile } from "../utils/auth";
import {
  getAllowedPagesForRole,
  resolveDefaultRoute,
  SAFE_FALLBACK_ROUTE,
} from "../utils/defaultPage";
import { usePermissions } from "../utils/permissions";

const RECAPTCHA_ENABLED =
  (process.env.REACT_APP_RECAPTCHA_ENABLED || "true").toLowerCase() === "true";

const normaliseAccessForStorage = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item ?? "").trim()).filter(Boolean);
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item ?? "").trim()).filter(Boolean);
      }
    } catch {
      // ignore JSON parse errors, fall back to split
    }
    return trimmed
      .split(/[,;]/)
      .map((item) => String(item ?? "").trim())
      .filter(Boolean);
  }
  return [];
};

export default function Login() {
  // ---- �^S�%^�<?�.< ----
  const [showPassword, setShowPassword] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [okMsg, setOkMsg] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const recaptchaRef = useRef(null); // ??????-???T, reset
  const { getLevel } = usePermissions();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setOkMsg("");

    const email = e.target.email.value.trim();
    const password = e.target.password.value;

    // --- ����Y� reCAPTCHA ��.��� ---
    if (RECAPTCHA_ENABLED && !recaptchaToken) {
      setErrorMsg('Please complete the "I\'m not a robot" verification.');
      return;
    }

    // --- ����Y� API base ---
    const apiBase = process.env.REACT_APP_API_URL;
    if (!apiBase) {
      setErrorMsg("API base URL is not configured. Please set REACT_APP_API_URL.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        email,
        password,
      };
      if (RECAPTCHA_ENABLED) {
        payload.recaptcha_token = recaptchaToken;
      }

      const res = await fetch(`${apiBase}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));

      // --- ��-��s�-�O?�<�-؊"S�?_�,݂�?��r reCAPTCHA ---
      if (!res.ok || !data.ok) {
        if (res.status === 401) {
          setErrorMsg("Invalid email or password.");
        } else if (res.status === 400) {
          setErrorMsg("reCAPTCHA validation failed. Please try again.");
        } else if (res.status === 403) {
          setErrorMsg("Access forbidden. Please contact the administrator.");
        } else {
          setErrorMsg(
            data.error ||
              data.message ||
              "Sign-in failed. Please check your credentials and verification."
          );
        }
        if (RECAPTCHA_ENABLED && recaptchaRef.current) recaptchaRef.current.reset();
        if (RECAPTCHA_ENABLED) setRecaptchaToken(null);
        return;
      }

     // --- �^?�SY��s�_��.��T��.��<?�.<��^�SS user �"_�?� pp_auth��O�,݄�?�T pp_user �>,�r1��% ---
      if (!data.token) {
        // ��'�<��^� token ��-�,��,��^�T��.���O�?��.?�?؇T��.��?��^?�O_����Z�?`
        setErrorMsg("Login succeeded but token missing. Please try again.");
        if (RECAPTCHA_ENABLED && recaptchaRef.current) recaptchaRef.current.reset();
        if (RECAPTCHA_ENABLED) setRecaptchaToken(null);
        return;
      }
      const token = data.token;
      const custAccess = normaliseAccessForStorage(
        data.user?.cust_access ?? data.user?.custAccess
      );
      const whsAccess = normaliseAccessForStorage(
        data.user?.whs_access ?? data.user?.whsAccess
      );

      const user = {
        email: data.user?.email || email,
        role:  data.user?.role  || "user",
        name:  data.user?.name  || "",
        company:       data.user?.company || "",
        company_code:  data.user?.company_code || "",
        remark:        data.user?.remark || "",
        cust_access:   custAccess,
        whs_access:    whsAccess,
        default_page_id: data.user?.default_page_id ?? null,
        role_default_page_id: data.user?.role_default_page_id ?? null,
        landing_route: data.user?.landing_route ?? "",
      };
      // camelCase aliases for convenience (legacy components may rely on either shape)
      user.custAccess = custAccess;
      user.whsAccess = whsAccess;

      const allowedPages = getAllowedPagesForRole(user.role, getLevel);

      const computeFallbackRoute = (profileData = null) => {
        const overrides = profileData || {};
        const allowed = allowedPages.length > 0 ? allowedPages : getAllowedPagesForRole(user.role, getLevel);
        const resolved = resolveDefaultRoute({
          user,
          role: user.role,
          getLevel,
          userDefaultPageId: overrides.user_default_page_id ?? user.default_page_id,
          roleDefaultPageId: overrides.role_default_page_id ?? user.role_default_page_id,
          allowedPagesOverride: allowed,
        });
        return resolved || SAFE_FALLBACK_ROUTE;
      };

      saveAuth(token, user);

      let landingRoute = "";
      try {
        const profile = await refreshUserProfile();
        landingRoute = profile?.landing_route || "";
        if (!landingRoute) {
          landingRoute = computeFallbackRoute(profile);
        }
      } catch (profileError) {
        console.warn("Failed to refresh profile; using local fallback.", profileError);
        landingRoute = computeFallbackRoute();
      }

      const fromLocation = location.state?.from;
      const hasValidFrom =
        fromLocation &&
        typeof fromLocation === "object" &&
        fromLocation.pathname &&
        fromLocation.pathname !== "/login";
      const targetRoute = hasValidFrom
        ? `${fromLocation.pathname}${fromLocation.search || ""}${fromLocation.hash || ""}`
        : landingRoute || SAFE_FALLBACK_ROUTE;

      setOkMsg("Signed in successfully. Redirecting...");
      setTimeout(() => navigate(targetRoute, { replace: true }), 600);

    } catch (err) {
      console.error(err);
      setErrorMsg("Unable to reach the server. Please try again later.");
      if (RECAPTCHA_ENABLED && recaptchaRef.current) recaptchaRef.current.reset();
      if (RECAPTCHA_ENABLED) setRecaptchaToken(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100">
      <div className="w-[300px] rounded-2xl bg-white px-6 py-4 shadow-lg">
        {/* Logo + Title */}
        <div className="mb-1 flex flex-col items-center space-y-1">
          <img src="/logo-triangle.png" alt="PortPilot Logo" className="h32 w-32" />
          <h1 className="text-gray-900 text-s font-bold">Supply Chain Intelligration</h1> 
          {/*<h2 className="text-center text-xs font-medium -mt-1">Supply Chain Intelligration</h2> */}
        </div>

        {/* <h1 className="text-center text-sm font-bold mb-3">Sign in</h1> */}

        {/* Form */}
        <form className="space-y-3" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              placeholder="admin@test.com"
              className="mt-1 w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="********"
                className="mt-1 w-full rounded-md border border-gray-300 px-2 py-1.5 pr-9 text-sm shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
                required
              />
              <button
                type="button"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
                className="absolute inset-y-0 right-2 my-auto text-xs text-blue-600 hover:underline"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* reCAPTCHA */}
          {RECAPTCHA_ENABLED && (
            <div className="flex justify-center">
              <div className="transform scale-[0.92] origin-top">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  size="compact"
                  onChange={(token) => setRecaptchaToken(token)}
                  onExpired={() => setRecaptchaToken(null)}
                />
              </div>
            </div>
          )}

          {/* Messages */}
          {errorMsg && (
            <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-md px-2 py-1">
              {errorMsg}
            </div>
          )}
          {okMsg && (
            <div className="text-xs text-green-700 bg-green-50 border border-green-200 rounded-md px-2 py-1">
              {okMsg}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-md bg-blue-600 px-3 py-2 text-white text-base font-medium hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        {/* Debug Info for missing API base */}
        {!process.env.REACT_APP_API_URL && (
          <p className="mt-2 text-xs text-red-500 text-center">
            �s��,? Missing REACT_APP_API_URL in .env
          </p>
        )}
      </div>
    </div>
  );
}
